<template>
  <v-app>
    <v-content>
      <v-snackbar v-model="snackbar" :timeout="3000" :top="true">
        {{ snackbartext }}
        <v-btn color="pink" flat @click="snackbar = false">{{
          $t("Close")
        }}</v-btn>
      </v-snackbar>
      <v-row class="fill-height">
        <v-col class="text-center align-self-center">
          <span style="text-transform: uppercase;">{{
            $t("Create Account")
          }}</span>
          <v-card
            class="mx-auto pa-5"
            style="background-color: #eeeeee; border-radius: 4px; border: 3px solid #dddddd;"
            :style="{ width: $vuetify.breakpoint.xs ? '100%' : '400px' }"
          >
            <v-row>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-col class="pl-12 ml-12">
                <router-link to="/front" style="text-decoration:none;">
                  <v-btn large icon color="error" outlined>
                    <v-icon large>fas fa-times</v-icon>
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
            <router-link to="/front">
              <v-img src="/wenewz_middle_2color.svg" />
            </router-link>
            <v-form ref="form" @submit.prevent="submitRegister" class="pt-5">
              <v-text-field
                :label="$t('Username')"
                v-model="username"
                required
                :rules="[rules.usernameRequired]"
              />
              <v-text-field
                :label="$t('Password')"
                v-model="password"
                type="password"
                required
                :rules="[rules.passwordRequired]"
              />
              <v-text-field
                :label="$t('Repeat password')"
                v-model="password2"
                type="password"
                required
                :rules="[rules.required, rules.passwordMatch]"
              />
              <v-text-field
                :label="$t('Email')"
                v-model="email"
                required
                :rules="[rules.emailRequired, rules.validEmail]"
              />
              <small
                v-html="
                  $t(
                    'By signing in to WeNewz, you agree to our Terms and Privacy Policy.'
                  )
                "
              ></small>
              <v-btn block type="submit" class="mt-5">{{
                $t("Register new user")
              }}</v-btn>
            </v-form>
            <v-divider></v-divider>
            <div>
              <span>{{ $t("If you already got an user") }} </span>
              <br />
              <span>
                <router-link to="/login">{{ $t("Click here") }}</router-link
                >!
              </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import messages from "./modules/lang/export";
export default {
  i18n: { messages },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      password2: "",
      acceptedtos: false,
      snackbar: false,
      snackbartext: "",
      rules: {
        required: value => !!value || this.$t("Required"),
        usernameRequired: value => !!value || this.$t("Username Required"),
        emailRequired: value => !!value || this.$t("Email Required"),
        validEmail: value => {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(value) || this.$t("Valid Email Required");
        },
        passwordRequired: value => !!value || this.$t("Password are required"),
        passwordMatch: value => {
          return this.password == value || this.$t("Passwords must match");
        }
      }
    };
  },
  watch: {},
  methods: {
    submitRegister() {
      this.snackbartext = this.$t("trying to register");
      this.snackbar = true;
      if (this.$refs.form.validate()) {
        let _userobj = {
          Email: this.email,
          Password: this.password,
          Nickname: this.username
        };
        this.$store
          .dispatch("register", _userobj)
          .then(resp => {
            this.snackbartext = this.$t("Success");
            this.snackbar = true;
            setTimeout(
              () => this.$router.push({ name: "profilesettings" }),
              600
            );
          })
          .catch(err => {
            console.error(err);
            this.snackbartext = this.$t("Couldnt create user");
            this.snackbar = true;
          });
      } else {
        this.snackbartext = this.$t("Couldnt create user");
        this.snackbar = true;
      }
    }
  }
};
</script>
